"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressMessage = exports.StyledRightIcon = exports.StyledMiniProgressBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _text = require("../../../styles/2_commonComponentStyles/text");

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var verticalMarginDefault = '1rem';

var StyledMiniProgressBar = _styledComponents.default.div.withConfig({
  displayName: "MiniProgressBarstyles__StyledMiniProgressBar",
  componentId: "j8hoqf-0"
})(["margin-top:", ";margin-bottom:", ";.c-mini-progress-bar-wrapper{background-color:", ";height:", ";width:100%;display:flex;flex-direction:column;justify-content:space-around;}.c-mini-progress-bar-label{display:flex;flex-direction:row;justify-content:space-between;align-items:center;}.c-mini-progress-bar-percent-complete{background-color:", ";;height:100%;text-align:right;z-index:+1;&.c-mini-progress-bar-error{background-color:", ";;}}.c-mini-progress-bar-message{line-height:1rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:18rem;display:inline-block;@media only screen and (min-width:", "){width:auto;max-width:39rem;}}.c-mini-progress-bar-spinner{animation-name:spin;animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;transform-origin:50% 50%;}@keyframes waitForProgressCompletion{0%{opacity:0;}99%{opacity:0;}100%{opacity:100;}}@keyframes waitForProgressCompletionWithFadeIn{0%{opacity:0;}75%{opacity:0;}100%{opacity:100;}}@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}.c-mini-progress-bar-animation{transition:width 0.2s ease-out;}"], verticalMarginDefault, verticalMarginDefault, function (props) {
  return props.theme.c_background_progressBar;
}, function (props) {
  return props.theme.miniProgressBarHeight;
}, function (props) {
  return (0, _text.getForegroundColor)(props, 'primary');
}, function (props) {
  return (0, _text.getForegroundColor)(props, 'danger');
}, function (props) {
  return props.theme.mediumBreak;
});
/**
 * The animation below relies on the timing of the animation on the progress bar (currently above).
 * It will wait for this to complete before transitioning in.
 */


exports.StyledMiniProgressBar = StyledMiniProgressBar;
var StyledRightIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "MiniProgressBarstyles__StyledRightIcon",
  componentId: "j8hoqf-1"
})(["cursor:pointer;", ""], function (props) {
  return props.waitforprogressbarcompletion === 'true' ? "\n      animation-name: ".concat(props.fadein === 'true' ? 'waitForProgressCompletionWithFadeIn' : 'waitForProgressCompletion', ";\n      animation-duration: ").concat(props.fadein === 'true' ? '700ms' : '500ms', ";\n    ") : '';
});
exports.StyledRightIcon = StyledRightIcon;

var ProgressMessage = _styledComponents.default.span.withConfig({
  displayName: "MiniProgressBarstyles__ProgressMessage",
  componentId: "j8hoqf-2"
})(["color:", ";"], function (props) {
  return (0, _text.getForegroundColor)(props);
});

exports.ProgressMessage = ProgressMessage;